import { useEffect } from 'react';

const NOTHS_WEB_KEY = '72692d65-6a1f-493e-913d-e372b78f5c9a';

interface UseSmartAppBannerOptions {
  hide?: boolean;
}

export const useSmartAppBanner = ({ hide = false }: UseSmartAppBannerOptions = {}) => {
  useEffect(() => {
    if (hide) {
      return;
    }

    // AppsFlyer renders its banner into the element matched by `bannerContainerQuery` below. Provide that
    // container ourselves, positioned fixed so the banner overlays the page rather than being injected in
    // flow and pushing content down (CLS). If AppsFlyer decides not to show a banner the empty, fixed
    // container occupies no layout space, so there is no reserved gap.
    const container = document.createElement('div');
    container.id = 'smart-banner';
    container.style.position = 'fixed';
    container.style.top = '0';
    container.style.left = '0';
    container.style.right = '0';
    container.style.zIndex = '100';
    document.body.insertBefore(container, document.body.firstChild);

    const script = document.createElement('script');
    script.id = 'smart-banner-app';

    // Appsflyer smart banner SDK docs: https://dev.appsflyer.com/hc/docs/dl_smart_banner_v2
    script.innerHTML = `!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${NOTHS_WEB_KEY}"}})
    AF('banners', 'showBanner', { bannerContainerQuery: "#smart-banner", bannerZIndex: 100 })`;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);

      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };
  }, [hide]);
};
